<template>
    <grid :columnDefs="columnDefs" :rowData="rowData" :isAutoWidth="true" :autoWidthExclude="['message']"> </grid>
</template>

<script>
    import api from '../../../api';
    import { GUEST_VERIFICATIONS_ENDPOINT } from '../../../endpoints';
    import { formatResponseError } from '../../../utils/api';
    import grid from '../../generic/grid/grid.vue';
    export default {
        components: { grid },
        data() {
            return {
                rowData: [],
            };
        },
        computed: {
            columnDefs() {
                return [
                    {
                        field: 'meta_reservation_id',
                        headerName: 'Invoice',
                        cellRenderer: ({ data }) =>
                            data.meta_reservation_id
                                ? `<a href="/app/reservation/edit/invoice/${data.meta_reservation_id}">${data.meta_reservation_id}</a>`
                                : 'System Log',
                    },
                    {
                        field: 'created',
                        type: 'dateTimeColumn',
                        headerName: 'Created',
                    },

                    {
                        field: 'message',
                        headerName: 'Message',
                        autoWidthExclude: true,
                    },
                ];
            },
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            async fetchData() {
                try {
                    const { data } = await api.get(`${GUEST_VERIFICATIONS_ENDPOINT()}logs/`);
                    this.rowData = data;
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not fetch verifications logs',
                    });
                }
            },
        },
    };
</script>

<style></style>
